module.exports = __webpack_public_path__ + "static/media/mascota2.b2a1ae12.png";